import { defineStore } from "pinia";
import type {
  Country,
  Booking,
  Business,
  Membership,
  ClientGiftCard,
} from "~/types";
import { BusinessMenu } from "#components";

export const useAccountStore = defineStore("accountStore", () => {
  const isMenuOpen = ref<boolean>(false);
  const countries = ref<Country[]>([]);
  const bookings = ref<Booking[]>([]);
  const canceledBooking = ref<null | Booking>(null);
  const cancelBookingOpen = ref<boolean>(false);
  const businesses = ref<Business[]>([]);
  const memberships = ref<Membership[]>([]);
  const goToMemberships = ref<boolean>(false);
  const myGiftCards = ref<ClientGiftCard[]>([] as ClientGiftCard[]);
  const slideover = useSlideover();

  const openMenu = () => {
    slideover.open(BusinessMenu);
    // isMenuOpen.value = !isMenuOpen.value;
  };

  function $reset() {
    isMenuOpen.value = false;
    countries.value = [];
    bookings.value = [];
    canceledBooking.value = null;
    cancelBookingOpen.value = false;
    businesses.value = [];
    memberships.value = [];
    goToMemberships.value = false;
    myGiftCards.value = [];
  }

  return {
    isMenuOpen,
    countries,
    bookings,
    canceledBooking,
    cancelBookingOpen,
    businesses,
    memberships,
    goToMemberships,
    myGiftCards,
    openMenu,
    $reset,
  };
});
